import { GET_USER_PROXY } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    user_proxies: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_USER_PROXY: {
            return {
                ...state,
                user_proxies: action.payload,
            };
        }
        default:
            return state;
    }
};
